import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { read } from '../lib/store.js';

function silhouetteSVG(num) {
  const n = esc(num);
  return `
    <svg class="silhouette" viewBox="0 0 200 220" preserveAspectRatio="xMidYMid slice" TINA-hidden="true">
      <text class="ghost" x="100" y="200" text-anchor="middle" style="font-size:200px">${n}</text>
      <g class="tick">
        <path d="M 8 8 L 8 18 M 8 8 L 18 8" />
        <path d="M 192 8 L 192 18 M 192 8 L 182 8" />
        <path d="M 8 212 L 8 202 M 8 212 L 18 212" />
        <path d="M 192 212 L 192 202 M 192 212 L 182 212" />
      </g>
      <rect class="label-bg" x="24" y="14" width="152" height="10" />
      <text class="label-tx" x="100" y="21" text-anchor="middle">DOSSIER /// SUBJECT ${n} /// CLASSIFIED</text>
      <path class="body" d="M 14 220 L 24 178 L 60 160 L 80 150 L 120 150 L 140 160 L 176 178 L 186 220 Z" />
      <path class="neck" d="M 82 150 L 82 132 L 118 132 L 118 150 Z" />
      <path class="body" d="M 70 78 L 70 106 C 70 122 82 132 100 132 C 118 132 130 122 130 106 L 130 78 Z" />
      <path class="jaw-shadow" d="M 78 118 L 122 118 L 118 126 C 112 130 88 130 82 126 Z" />
      <path class="cap" d="M 64 78 L 64 56 C 64 44 78 36 100 36 C 122 36 136 44 136 56 L 136 78 Z" />
      <rect class="cap" x="56" y="76" width="88" height="6" />
      <rect class="cap-shadow" x="64" y="76" width="72" height="3" />
      <rect x="92" y="50" width="16" height="10" fill="#1a0c00" />
      <text x="100" y="58" text-anchor="middle" fill="#f3ead8" style="font:700 7px 'Anton',sans-serif;letter-spacing:0.05em">GG</text>
      <path d="M 24 178 L 60 160 L 80 150 L 80 162 L 60 172 L 32 192 Z" fill="var(--blaze)" />
      <path d="M 176 178 L 140 160 L 120 150 L 120 162 L 140 172 L 168 192 Z" fill="var(--blaze)" />
      <rect class="frame" x="4" y="4" width="192" height="212" />
    </svg>
  `;
}

export function renderRoster() {
  const grid = $('#roster-grid');
  if (!grid) return;
  grid.innerHTML = '';
  const roster = read('roster');

  const totalKidsEl = document.getElementById('total-kids');
  if (totalKidsEl) {
    const totalKids = roster.reduce((sum, p) => sum + (parseInt(p.kids, 10) || 0), 0);
    totalKidsEl.textContent = totalKids;
  }

  roster.forEach(p => {
    const card = document.createElement('div');
    card.className = 'player';
    card.innerHTML = `
      <div class="head">
        <span class="role">${esc(p.role)}</span>
        <span class="num">#${esc(p.num)}</span>
      </div>
      <div class="photo">
        ${silhouetteSVG(p.num)}
        <span class="photo-tag">SUBJECT_${esc(p.num)}<br/>// CLASSIFIED</span>
        <span class="photo-num">${esc(p.num)}</span>
      </div>
      <div class="name-block">
        <div class="ign">${esc(p.ign)}</div>
        <div class="real">${esc(p.name)} · ${esc(p.age)} · ${esc(p.kids)} ${parseInt(p.kids, 10) === 1 ? 'kid' : 'kids'}</div>
      </div>
      <div class="stats">
        <div class="s"><div class="k">KDA</div><div class="v">${esc(p.kda)}</div></div>
        <div class="s"><div class="k">RANK</div><div class="v">${esc(p.rank)}<small>#${esc(p.rankNum)}</small></div></div>
        <div class="s"><div class="k">AVG SLEEP</div><div class="v">${esc(p.sleep)}</div></div>
        <div class="s"><div class="k">DIAPERS</div><div class="v">${esc(p.diapers)}</div></div>
      </div>
      <div class="bar"><span>// ${esc(p.note)}</span></div>
    `;
    grid.appendChild(card);
  });
}
